import type { HblPrice } from '@/utils/types'

export const hblPriceIncludes = {
    'calculated_price': [
        'unitPrice',
        'listPrice',
        'calculatedTaxes',
        'totalPrice',
        'referencePrice',
    ],
    'cart_list_price': [
        'price',
        'discount',
        'percentage',
    ],
    'cart_tax_calculated': [
        'tax',
        'taxRate',
    ],
}

export function hblMapPrice (calculatedPrice: any): HblPrice {
    return {
        referencePrice: calculatedPrice?.referencePrice,
        regularPrice: calculatedPrice?.unitPrice,
        specialPrice: calculatedPrice?.listPrice?.price,
        // @ts-ignore
        totalPrice: calculatedPrice.totalPrice,
        // @ts-ignore
        discount: calculatedPrice?.listPrice?.discount,
        percentage: calculatedPrice?.listPrice?.percentage,
        tax: calculatedPrice?.calculatedTaxes[0]?.tax,
        taxRate: calculatedPrice?.calculatedTaxes[0]?.taxRate
    }
}
